module.exports = __webpack_public_path__ + "img/cfd8646.svg";